import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract.js'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { checkCreditInfo } from '@/api/partner/creditInfo'
import { getContractsByCompanyUuids } from '@/api/partner/contract'
import { dateCompare } from '@/utils/commonUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'

export class BasicTabHP extends TabBookingAbstract {
  constructor(view) {
    super(view)
    this.$t = this.view.$t
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  /**
   * 更新页面显示
   */
  updateView() {
    // 信控超期提醒
    this.checkCredit()
  }

  loadCompanyOffice() {
    // todo  此处 officeList 未加载结束
    /* const job = this.job
    const office = this.view.officeList.filter(p => p.officeId === job.salesOffice)[0]
    if (office) {
      this.view.txtSalesOffice = office.chineseName
    } else {
      this.view.txtSalesOffice = ''
    }*/
    this.view.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', this.job.salesOffice, 'chineseName')
  }

  // 加载 客户属性
  async loadCustomerLevel() {
    let company = await Company.getCompanyById(this.job.customerId)
    this.view.advancePaymentLabel = company && company.ifAdvancePayment ? this.view.$t('Partners.IfAdvancePayment') : ''
    company = new Company(company)
    let customer = await company.getCustomerDetail()
    if (customer) {
      customer = new Customer(customer)

      const customerType = await customer.getCustomerType()
      if (customerType) {
        this.view.customerLevel.level = customerType.typeId
        this.view.customerLevel.customerName = customerType.chineseName
      }
    }
    /* 获取合约状态 */
    getContractsByCompanyUuids([company.uuid]).then(async res => {
      if (res.data.length > 0) {
        const now = new Date()
        if (res.data.find(p => dateCompare(p.endDate, now) >= 0)) {
          company.contractStatus = 2
        } else {
          company.contractStatus = 1
        }
      } else {
        company.contractStatus = 0
      }

      const contractState = this.view.contractStatuses[Number(company.contractStatus)]
      this.view.contractStatusLabel = contractState ? contractState.label : ''
      this.view.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.job))
    })
  }

  checkCredit() {
    this.view.creditTip.showWarningImageA = false
    this.view.creditTip.showWarningImageB = false
    this.view.creditTip.showWarningImageC = false

    if (this.view.configValue.creditOpen) {
      const job = this.job
      // 委托单位
      if (job && job.customerId > 0) {
        this.checkCreditByCompany(job.customerId, 1, job.uuid)
      }
      // 指定货代理
      if (job && job.designationAgent > 0) {
        this.checkCreditByCompany(job.designationAgent, 2, job.uuid)
      }
      // 目的港代理
      if (job && job.destinationAgent > 0) {
        this.checkCreditByCompany(job.destinationAgent, 3, job.uuid)
      }
    }
  }
  /**
   * type代表不同的角色
   */
  checkCreditByCompany(companyId, type, jobUuid = null) {
    const callback = credit => {
      let checkCredit = false
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          const config = this.getCreditEDISetting()
          if (config.booking) {
            if (credit.amountExceeded) { tip += this.view.$t('Partners.limit') }
            if (credit.dateExceeded) { tip += this.view.$t('Partners.accountPeriod') }
            if (tip !== '') {
              const toolTip = this.view.$t('Partners.parter') + tip + this.view.$t('SeaExport.HasExceeded')
              if (type === 1) {
                this.view.creditTip.showWarningImageB = true
                this.view.creditTip.warningImageBTip = toolTip
              } else if (type === 2) {
                this.view.creditTip.showWarningImageA = true
                this.view.creditTip.warningImageATip = toolTip
              } else if (type === 3) {
                this.view.creditTip.showWarningImageC = true
                this.view.creditTip.warningImageCTip = toolTip
              }
              checkCredit = true
            }
          }
        }
      }
      if (!credit || !checkCredit) {
        /* const company = this.context.companyList.find(p => p.cmpIdx === companyId)
        if (company && company.ifOpenSop && this.sopConfigOpen) {
          // if (type === 1 && view.imageB) {
          //   if (view.imageB) {
          //     view.imageB.visible = true
          //   }
          // } else if (type === 2) {
          //   if (view.imageA) {
          //     view.imageA.visible = true
          //   }
          // } else if (type === 3) {
          //   if (view.imageC) {
          //     view.imageC.visible = true
          //   }
          // }
        }*/
      }
    }
    checkCreditInfo({ [companyId]: companyId, jobUuid: jobUuid }).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  getCreditEDISetting() {
    const setting = this.config.get('creditBlockEDI')
    const a = setting.split(',')
    const r = {}
    for (const o of a) {
      let lock = false
      if (o.split('-')[1] === '1') {
        lock = true
      }
      r[o.split('-')[0]] = lock
    }
    return r
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
      job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.userDefinedRoleOffice1 = office ? office.officeId : 0
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
      job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.userDefinedRoleOffice2 = office ? office.officeId : 0
    }
  }
}
